<template>
  <div>
    <ui-modal
      :shown="showModal"
      id="modal-vm18"
      class="modal-vm18"
      no-close
    >
      <template #header>
        <slot name="header">
        <div
          class="d-flex flex-column justify-content-center align-items-center text-center container"
        >
          <svg-vm18-vivaincontri
            v-if="isVivaincontri"
          />
          <svg-vm18-skokka
            v-else
          />

          <h2
            id="modal-vm18__title"
            class="text-center font-weight-bolder text-2xl mt-3"
          >
            {{ i18n.pleaseRead }}
          </h2>
        </div>
        </slot>
      </template>
      <template #body>
        <slot name="body">
        <div
          class="container d-flex flex-column  justify-content-center align-items-center"
        >
          <p
            id="modal-vm18__text"
            class="text-center max-w-320"
            v-html="i18n.eighteenYearOld"></p>
          <hr class="my-1 border-0">
          <p
            id="modal-vm18__terms-and-conditions"
            class="text-center m-0 p-0"
            v-text="i18n.termsAndConditions"></p>
          <ui-button
            class="m-0 p-0"
            :href="tcUrl"
            :data-hreh="tcUrl"
            button-type="blank"
            normal-case
            no-box-shadow
            :label="i18n.tac"/>
        </div>
        </slot>
      </template>
      <template #footer>
        <slot name="footer">
        <div class="container d-flex flex-column justify-content-center align-items-center">
          <ui-button
            class="m-0"
            appearance="primary"
            @click="accept"
            :label="i18n.accept"/>
          <ui-button
            class="m-0"
            href="https://www.google.com"
            rel="noopener nofollow"
            button-type="blank"
            normal-case
            no-box-shadow
            :label="i18n.refuse"/>
        </div>
        </slot>
      </template>
    </ui-modal>
  </div>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";
import Url from "domurl";

import {
  privacyCookieName,
  getLightboxName,
  canUseCookies,
} from '../utils';

const COOKIE_NAME = 'adult_cookie';

export default {
  props: {
    privacyCookie: {
      type: Boolean,
      required: true,
      default: false
    },
    tcUrl: {
      type: String,
      required: true
    },
    isVivaincontri: {
      type: Boolean,
      default: false
    },
  },
  components: {
    UiModal: () => import(/* webpackChunkName: "chunk-ui-modal", webpackMode: "eager"  */ './ui/ui-modal.vue'),
    UiButton: () => import(/* webpackChunkName: "chunk-ui-button" */ './ui/ui-button.vue'),
    SvgVm18Skokka: () => import(/* webpackChunkName: "chunk-svg-vm18-skokka" */ './svg/vm18-skokka.vue'),
    SvgVm18Vivaincontri: () => import(/* webpackChunkName: "chunk-svg-vm18-vivaincontri" */ './svg/vm18-vivaincontri.vue'),
  },
  data() {
    return {
      lightboxName: null,
      adultCookie: false,
      i18n: {
        pleaseRead: gettext("Please read the following warning before continuing"),
        eighteenYearOld: String(gettext(" <b>I am over 18 years old</b>  and I accept the viewing of explicit texts and images intended for an <b>adult audience</b><br>")).replace("<br>", ".<br>"),
        accept: gettext("Accept"),
        refuse: gettext("Decline"),
        termsAndConditions: gettext("I have read and accept the"),
        tac: gettext("Terms and Conditions"),
      }
    }
  },
  computed: {
    showModal() {
      return this.$store.getters['ui/lightboxManager/lightboxIsShown'](this.lightboxName);
    }
  },
  mounted() {
    this.lightboxName = getLightboxName({el: this.$el});
    /**
     Manage the display status of cookies based on the presence of cookies and the user's country when privacy cookies are enabled.
     In countries where privacy cookies are required, both the adult cookie and the privacy cookie need to be checked.
     In countries where privacy cookies are not required, only the adult cookie needs to be checked.
     */
    const requiresPrivacyCookie = locations.privacy_cookie_country || false;
    const hasCookie = !!this.$cookies.get(COOKIE_NAME) || false;
    const hasPrivacyCookie = !!this.$cookies.get(privacyCookieName) || false;
    const url = new Url(window.location.href);

    const isLightboxQueryPresent = url.query.lightbox === 'true';

    const shouldRemoveFromQueue = requiresPrivacyCookie ? (hasCookie && hasPrivacyCookie) : hasCookie;

    if (shouldRemoveFromQueue && !isLightboxQueryPresent) {
      this.$store.dispatch("ui/lightboxManager/removeAndHide", this.lightboxName);
    }
  },
  watch: {
    privacyCookie() {
      if (this.privacyCookie && this.adultCookie) {
        this.$cookies.set(
          COOKIE_NAME,
          '1',
          '1d',
          '/',
          locations.cookie_domain);
      }
    }
  },
  methods: {
    accept() {
      if (canUseCookies) {
        this.$cookies.set(
          COOKIE_NAME,
          '1',
          '1d',
          '/',
          locations.cookie_domain);
      } else {
        this.adultCookie = true;
      }
      this.$store.dispatch("ui/lightboxManager/hide");
    },
  },
};
</script>

<style>
#modal-vm18__title,
#modal-vm18__text,
#modal-vm18__terms-and-conditions {
  color: var(--color-body);
}


</style>
